import { Outlet } from 'react-router-dom'
import styles from './MainLayout.module.css'
import CustomToaster from '@/components/Toaster'
import { LanguageSync } from '@/i18n/LanguageSync'

const MainLayout = () => {
  return (
    <LanguageSync>
      <div className={styles.layout}>
        <main className={styles.main}>
          <Outlet />
        </main>
        <CustomToaster />
      </div>
    </LanguageSync>
  )
}

export default MainLayout
